import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title", "aria-label"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FullScreen = _resolveComponent("FullScreen");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("button", {
    type: "button",
    title: $data.isFullscreen ? '退出全屏' : '全屏',
    "aria-label": $data.isFullscreen ? '退出全屏' : '全屏',
    onClick: _cache[0] || (_cache[0] = (...args) => $options.click && $options.click(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_FullScreen)]),
    _: 1
  })], 8, _hoisted_1);
}